<div mat-dialog-content>
    <p>Do you want to exit the game?</p>
</div>
<div mat-dialog-actions>
    <button mat-button class="button1" [mat-dialog-close]="false" cdkFocusInitial>No</button>
    <button mat-button class="button1 ml-auto" (click)="yes()">Yes</button>
</div>